import * as React from 'react';
import TextInput from '@/components/CustomRNPaper/TextInput';

const splitCharacters = ['-', '/', '.', '年', ' ', ':'];
function detectCharacter(mask: string): string {
  const c = splitCharacters.find((ch) => mask.includes(ch));
  return c || '';
}

function escapeForRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function TextInputWithMask(
  {
    inputButton,
    onChangeText,
    onChange,
    value,
    mask,
    disabled,
    ...rest
  }: React.ComponentProps<typeof TextInput> & {
    mask: string;
    value: string;
    inputButton: React.ReactNode;
    onChangeText: (text: string, maskLengthReached?: boolean) => void;
  },
  ref: any
) {
  const [controlledValue, setControlledValue] = React.useState<string>(value || '');

  const onInnerChange = (text: string) => {
    const splitCharacter = detectCharacter(mask);
    const maskParts = mask.split(splitCharacter);

    let trimmedText = text.trim();
    const format =
      maskParts[0].toLowerCase() +
      splitCharacter +
      maskParts[1].toLowerCase() +
      (maskParts[2] ? splitCharacter + maskParts[2].toLowerCase() : '');
    const match = maskParts[2]
      ? new RegExp(
          format
            .replace(/(\w+)\W(\w+)\W(\w+)/, '^\\s*($1)\\W*($2)?\\W*($3)?([0-9]*).*')
            .replace(/m|d|y|j|a|h/g, '\\d')
        )
      : new RegExp(
          format.replace(/(\w+)\W(\w+)/, '^\\s*($1)\\W*($2)?([0-9]*).*').replace(/m|h/g, '\\d')
        );
    const replaceValue = format.match(/\W/);
    const replace = (
      maskParts[2] ? `$1${splitCharacter}$2${splitCharacter}$3$4` : `$1${splitCharacter}$2$3`
    ).replace(new RegExp(escapeForRegExp(splitCharacter), 'g'), (replaceValue ?? '') as string);

    const isBackSpace = controlledValue.length > trimmedText.length;

    if (!isBackSpace) {
      trimmedText = trimmedText
        .replace(/(^|\W)(?=\d\W)/g, '$10')
        .replace(match, replace)
        .replace(/(\W)+/g, '$1');
    }

    if (onChangeText) {
      onChangeText(trimmedText, trimmedText.length === mask.length);
    }

    setControlledValue(trimmedText);
  };

  React.useEffect(() => {
    setControlledValue(value || '');
  }, [value]);

  return (
    <TextInput
      ref={ref}
      {...rest}
      disabled={disabled}
      value={controlledValue}
      onChangeText={onInnerChange}
      onChange={(e) => {
        onChange && onChange(e);
      }}
      maxLength={mask.length}
      right={inputButton}
    />
  );
}

export default React.forwardRef(TextInputWithMask);
